<template>
    <div class="loading" @touchmove.prevent>
        <transition name="fade">
            <div class="loading__loading" v-show="!loaded">
                <img src="@/assets/loading-box.png" class="loading__loading__box rotate">
                <!-- <div class="loading__loading__progress">
                    <div class="loading__loading__progress__bar"
                        v-bind:style="{ width: progress + '%' }"></div>
                </div> -->
                <p v-html="calculationProgress+'%'" class="loading__loading__progress"></p>
                <transition name="fade">
                    <img src="@/assets/loading-begin.png" class="loading__loading__begin"
                        v-show="showbtn" @click="enter">
                </transition>
            </div>
        </transition>
        <video class="loading__video"
            :class="{ android }"
            poster=""
            x5-playsinline
            playsinline
            webkit-playsinline
            preload="auto"
            src="http://cdn.shikehuyu.com/card/start.mp4?v=1.0.0">
        </video>
    </div>
</template>

<script>
export default {
    name: 'home',
    data() {
        return {
            showbtn: false,
            loaded: false,
            progress: 0,
            android: false,
            lock: true
        };
    },
    computed: {
        calculationProgress() {
            return Math.round(this.progress);
        },
    },
    methods: {
        load() {
            const imgs = [
                'icon-music-on.png?v=1.0.0',
                'icon-music-off.png?v=1.0.0',
                'welcome-title.png?v=1.0.0',
                'welcome-main.png?v=1.0.0',
                'welcome-text.png?v=1.0.0',
                'welcome-enter.png?v=1.0.0',
                'welcome-bg.png?v=1.0.0',
                'homepage-people.png?v=1.0.5',
                'homepage-BG.png?v=1.0.0',
                'homepage-clickhand.png?v=1.0.0',
                'homepage-hand1.png?v=1.0.0',
                'homepage-hand2.png?v=1.0.0',
                'homepage-hand3.png?v=1.0.0',
                'homepage-qaGF.png?v=1.0.0',
                'homepage-qaWSD.png?v=1.0.0',
                'homepage-qaYMX.png?v=1.0.0',
                'homepage-music.png?v=1.0.0',
                'homepage-line1.png?v=1.0.0',
                'homepage-geometry1.png?v=1.0.1',
                'homepage-geometry2.png?v=1.0.1',
                'homepage-geometry3.png?v=1.0.1',
                'homepage-geometry4.png?v=1.0.1',
                'homepage-geometry5.png?v=1.0.1',
                'homepage-geometry6.png?v=1.0.0',
                'homepage-geometry7.png?v=1.0.0',
                'homepage-geometry8.png?v=1.0.0',
                'homepage-geometry9.png?v=1.0.0',
                'homepage-music-off.png?v=1.0.0',
                'game-link.png?v=1.0.3',
                'game-logo.png?v=1.0.2',
                'game-bg.png?v=1.0.0',
                'game-title-video.png?v=1.0.2',
                'game-play.png?v=1.0.0',
                'game-subtitle-video.png?v=1.0.0',
                'game-title-2.png?v=1.0.0',
                'game-subtitle-2.png?v=1.0.3',
                'game-light.png?v=1.0.0',
                'game-card.png?v=1.0.2',
                'game-lose.png?v=1.0.0',
                'game-again.png?v=1.0.0',
                'game-giveup.png?v=1.0.0',
                'game-click.png?v=1.0.1',
                'lottery-title.png?v=1.0.0',
                'lottery-subtitle.png?v=1.0.0',
                'lottery-box.png?v=1.0.0',
                'lottery-btn.png?v=1.0.0',
                'lottery-gift-0.png?v=1.0.0',
                'lottery-gift-1.png?v=1.0.0',
                'lottery-gift-2.png?v=1.0.0',
                'lottery-modal.png?v=1.0.0',
                'lottery-again.png?v=1.0.0',
                'lottery-light-on.png?v=1.0.0',
                'lottery-light-off.png?v=1.0.0',
                'gift.png?v=1.0.0',
                'form-rule.png?v=1.0.0',
                'form-title.png?v=1.0.0',
                'form-gift-bg.png?v=1.0.0',
                'form-submit.png?v=1.0.0',
                'form-subtitle.png?v=1.0.2',
                'form-desc.png?v=1.0.2',
                'form-line.png?v=1.0.0',
                'form-close.png?v=1.0.0',
                'share-logo.png?v=1.0.2',
                'share-example.png?v=1.0.2',
                'share-text.png?v=1.0.1',
                'share-save.png?v=1.0.0',
                'share-home.png?v=1.0.0',
                'share-poster-bg.png?v=1.0.2',
                'share-qrcode.png?v=1.0.0',
                'share-poster-text-0.png?v=1.0.0',
                'share-poster-text-1.png?v=1.0.0',
                'share-poster-text-2.png?v=1.0.0',
                'share-poster-text-3.png?v=1.0.0',
                'share-poster-text-4.png?v=1.0.0',
            ];
            const progress = 99 / imgs.length;
            const onload = () => {
                this.progress += progress;
                this.progress = this.progress > 98 ? 98 : this.progress;
                if (this.progress >= 98 && !this.lock) {
                    this.progress = 100;
                    setTimeout(() => {
                        this.showbtn = true;
                    }, 200);
                }
            };
            // const version = '1.0.1';
            imgs.forEach((src) => {
                const img = new Image();
                img.onload = onload;
                img.onerror = onerror;
                img.src = `http://cdn.shikehuyu.com/card/${src}`;
            });
        },
        enter() {
            if (!this.loaded) {
                this.loaded = true;
                this.video.play();
                // 加载音乐
                this.$bus.loadMusic();
            }
        },
        videoEnd() {
            this.$router.replace('welcome');
            // 播放背景音乐
            this.$bus.playMusic('bg');
        }
    },
    mounted() {
        this.video = document.querySelector('.loading__video');
        if (window.navigator.userAgent.match(/android/ig)) {
            this.video.addEventListener('timeupdate', () => {
                const rest = this.video.duration - this.video.currentTime;
                if (rest < 2 && !this.videoEnded) {
                    this.videoEnded = true;
                    setTimeout(() => {
                        this.videoEnd();
                    }, (rest - 1) * 1000);
                }
            });
            this.android = true;
        } else {
            this.video.addEventListener('ended', () => {
                this.videoEnd();
            });
        }
        // 预加载
        document.addEventListener('WeixinJSBridgeReady', () => {
            this.video.load();
            this.video.play();
            this.video.pause();
        });
        this.load();

        // 至少3秒
        setTimeout(() => {
            this.lock = false;
            if (this.progress >= 98) {
                this.progress = 100;
                setTimeout(() => {
                    this.showbtn = true;
                }, 200);
            }
        }, 3000);

        window.loading = this;
    },
};
</script>
<style lang="scss">
@import '../style/mixin.scss';
@import '../style/color.scss';
@import '../style/animation.scss';
.loading {
    @include fullscreen;
    overflow: hidden;
    &__video {
        width: 100vw;
        height: 100.5vh;
        object-fit: cover;
        background-size: contain;
        object-position: center bottom;
        z-index: 1;
        &.android {
            height: 109vh;
        }
    }
    &__loading {
        @include fullscreen;
        z-index: 2;
        background-color: #ffffff;
        display: flex;
        justify-content: center;
        &__box {
            width: 31vw;
            position: absolute;
            top: 34.7vh;
        }
        &__begin {
            width: 30vw;
            position: absolute;
            left: 50%;
            bottom: 22.7vh;
            transform: translate(-50%,0);
        }
        &__progress {
            position: absolute;
            top: 55.17vh;
            // font-family: MicrosoftYaHei;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 4px;
            color: #5f5f5f;
            // width: 30.4vw;
            // height: 0.6vh;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/loading.vue